

































import Vue from 'vue'
import Tooltip from '@/common/components/Tooltip.vue'
import BaseImage from '@/common/components/BaseImage.vue'

import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import { ProductOption } from '@/stockLibrary/queries/types'

export default Vue.extend({
  components: {
    Tooltip,
    BaseImage
  },
  props: {
    productOptions: {
      type: Array as () => ProductOption[],
      required: true
    },
    selectedOption: {
      type: String,
      required: true
    }
  },
  computed: {
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    placeholderSquare() {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  methods: {
    selectOption(option: ProductOption) {
      if (!option.selectable) return
      this.$emit('changeFirstOption', option.id)
    }
  }
})
